export default "__VITE_ASSET__BIBULsfq__"